export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/visual-cues-icon.svg?1c7fb255cef059f066abd7eaef800c6b";